<script>
import Utils from "@/services/utils.js";
import {useDvFlagAccess} from "../../../services/featureFlag";

export default {
  name: "NameTableRenderer",
  props: ["object"],
  computed: {
    link() {
      return useDvFlagAccess("beepiz-remote-monitoring-can:update")
        ? {
            name: "RemoteMonitoringShow",
            params: { id: this.object.id },
          }
        : null;
    },
    linkTag() {
      return useDvFlagAccess("beepiz-remote-monitoring-can:update") ? "router-link" : "span";
    },
    classNames() {
      return useDvFlagAccess("beepiz-remote-monitoring-can:update")
        ? "font-weight-bold underline"
        : "text-muted";
    },
  },
  props: ["object"],
};
</script>
<template>
  <span class="renderer">
    <router-link :is="linkTag" :to="link" :class="classNames">
      {{ object.name }}
    </router-link>
  </span>
</template>
